<template>
  <p>
    <span class="modal-body-text"
      >You are about to remove 1 reward access token...</span
    ><br /><br />
    <span class="modal-body-text">{{ description }}</span
    ><br /><br />
    <span class="modal-body-text">Are you sure you want to continue?</span>
    <br />
  </p>
</template>

<script>
export default {
  name: "remove-reward-access-token-modal",
  props: {
    data: null
  },
  computed: {
    description() {
      if (this.data && this.data.programName && this.data.clientName) {
        return (
          "Program: " +
          this.data.programName +
          " - Client: " +
          this.data.clientName
        );
      }
      return "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modal/RemoveRewardAccessToken.vue